import React from 'react';
import './shimmer.css';

const shimmer = () => {
  return (
    <div className="shimmer-wrapper">
      {/* Multiple shimmer blocks to simulate loading content */}
      <div className="shimmer-block"></div>
      <div className="shimmer-block large"></div>
      <div className="shimmer-block"></div>
    </div>
  );
};

export default shimmer